<template>
    <div class="space--header">
      <div class="space--header__avatar">
        <img :src="avatar" v-if="avatar">
      </div>
      <div class="space--header__details">
        <h1 class="space--header__title" v-if="title">{{ title }}</h1>
        <template v-if="floor">
          <div class="space--header__address" v-if="floor">{{ translatedAddress }}</div>
        </template>
        <template v-else>
          <div class="space--header__address" v-if="address">{{ address }}</div>
        </template>
      </div>
    </div>
</template>

<script>

export default {
  name: 'ButtonPrimary',
  data: () => ({
  }),
  components: {
  },
  computed: {
    translatedAddress() {
      const translations = this.$store.getters.language;
      return translations[this.floor] || this.floor;
    }
  },
  props: {
    title: { type: String, default: null },
    address: { type: String, default: null },
    floor: { type: String, default: null },
    avatar: { type: String, default: null },
  },
  mounted () {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../scss/global/includes";

.space--header {
  width: 100%;
  background: $divider-light;
  color: $primary-grey;
  padding: 32px;
  border-radius: 4px;
  display: grid;
  gap: 16px;
  grid-template-columns: 54px auto;
}

.space--header__avatar {
    height: 54px;
    width: 54px;
    background: $white;
    z-index: 1001;
    border-radius: 50%;
    overflow: hidden;
}

.space--header__title {
  margin: 0 0 5px 0;
  @include responsive-text-size('Title--22--Bold');
}
.space--header__address {
  @include responsive-text-size('Title--18--Regular');
}
</style>
